import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_LABORATORYDEPARTMENT_LOAD,
    ACTION_LABORATORYDEPARTMENT_LOAD_BY_ID,
    ACTION_LABORATORYDEPARTMENTS_LOAD_BY_LABORATORYID,

    ACTION_LABORATORYDEPARTMENT_SAVE,

    ACTION_LABORATORYDEPARTMENT_CREATE,

    ACTION_LABORATORYDEPARTMENT_DELETE,

    ACTION_LABORATORYDEPARTMENT_VALIDATE,

    ILaboratoryDepartmentsLoadAction,
    ILaboratoryDepartmentLoadByIdAction,
    ILaboratoryDepartmentsLoadByLaboratoryIdAction,
    ILaboratoryDepartmentLoadFailureAction,
    ILaboratoryDepartmentLoadSuccessAction,

    ILaboratoryDepartmentSaveAction,
    ILaboratoryDepartmentSaveSuccessAction,
    ILaboratoryDepartmentSaveFailureAction,

    ILaboratoryDepartmentCreateAction,
    ILaboratoryDepartmentCreateSuccessAction,
    ILaboratoryDepartmentCreateFailureAction,

    ILaboratoryDepartmentDeleteAction,
    ILaboratoryDepartmentDeleteSuccessAction,
    ILaboratoryDepartmentDeleteFailureAction,

    ILaboratoryDepartmentValidateAction,
    ILaboratoryDepartmentValidateSuccessAction,
    ILaboratoryDepartmentValidateFailureAction,


    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    DeleteSuccess,
    DeleteFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/laboratoryDepartments";
import { laboratoryDepartmentsApi } from "../services/laboratoryDepartments";


export const
    getLaboratoryDepartmentsEpic = (action$): Observable<ILaboratoryDepartmentLoadSuccessAction | ILaboratoryDepartmentLoadFailureAction> => {
        return action$
            .ofType(ACTION_LABORATORYDEPARTMENT_LOAD)
            .mergeMap((_action: ILaboratoryDepartmentsLoadAction) => {
                return laboratoryDepartmentsApi
                    .getLaboratoryDepartments()
                    .map(response =>
                        LoadSuccess(response.laboratoryDepartments, undefined, undefined, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getLaboratoryDepartmentByIdEpic = (action$): Observable<ILaboratoryDepartmentLoadSuccessAction | ILaboratoryDepartmentLoadFailureAction> => {
        return action$
            .ofType(ACTION_LABORATORYDEPARTMENT_LOAD_BY_ID)
            .mergeMap((action: ILaboratoryDepartmentLoadByIdAction) => {
                return laboratoryDepartmentsApi
                    .getLaboratoryDepartmentById(action.id)
                    .map(response =>
                        LoadSuccess(response.laboratoryDepartment, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getLaboratoryDepartmentsByLaboratoryIdEpic = (action$): Observable<ILaboratoryDepartmentLoadSuccessAction | ILaboratoryDepartmentLoadFailureAction> => {
        return action$
            .ofType(ACTION_LABORATORYDEPARTMENTS_LOAD_BY_LABORATORYID)
            .mergeMap((action: ILaboratoryDepartmentsLoadByLaboratoryIdAction) => {
                return laboratoryDepartmentsApi
                    .getLaboratoryDepartmentsByLaboratoryId(action.laboratoryId)
                    .map(response =>
                        LoadSuccess(response.laboratoryDepartments, undefined, undefined, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setLaboratoryDepartmentEpic = (action$): Observable<ILaboratoryDepartmentSaveSuccessAction | ILaboratoryDepartmentSaveFailureAction> => {
        return action$
            .ofType(ACTION_LABORATORYDEPARTMENT_SAVE)
            .mergeMap((action: ILaboratoryDepartmentSaveAction) => {
                return laboratoryDepartmentsApi
                    .setLaboratoryDepartment(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.laboratoryDepartment, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createLaboratoryDepartmentEpic = (action$): Observable<ILaboratoryDepartmentCreateSuccessAction | ILaboratoryDepartmentCreateFailureAction> => {
        return action$
            .ofType(ACTION_LABORATORYDEPARTMENT_CREATE)
            .mergeMap((action: ILaboratoryDepartmentCreateAction) => {
                return laboratoryDepartmentsApi
                    .createLaboratoryDepartment(action.laboratoryId)
                    .map(response =>
                        CreateSuccess(response.laboratoryDepartment, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    deleteLaboratoryDepartmentEpic = (action$): Observable<ILaboratoryDepartmentDeleteSuccessAction | ILaboratoryDepartmentDeleteFailureAction> => {
        return action$
            .ofType(ACTION_LABORATORYDEPARTMENT_DELETE)
            .mergeMap((action: ILaboratoryDepartmentDeleteAction) => {
                return laboratoryDepartmentsApi
                    .deleteLaboratoryDepartment(action.laboratoryDepartmentId)
                    .map(_response =>
                        DeleteSuccess()
                    )
                    .catch(error =>
                        Observable.of(DeleteFailure(error.responseStatus))
                    )
            });
    },
    validateLaboratoryDepartmentEpic = (action$): Observable<ILaboratoryDepartmentValidateSuccessAction | ILaboratoryDepartmentValidateFailureAction> => {
        return action$
            .ofType(ACTION_LABORATORYDEPARTMENT_VALIDATE)
            .mergeMap((action: ILaboratoryDepartmentValidateAction) => {
                return laboratoryDepartmentsApi
                    .validateLaboratoryDepartment(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.laboratoryDepartment, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }